import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import RequestCard from '../RequestCard/RequestCard';
import { setRequestDrawerVisible } from '../../actions/requestCardActions';
import BottomDrawer from '../BottomDrawer/BottomDrawer';

const RequestCardDrawer = ({
  calendarIcon,
  onClose,
  onCalendarClick,
  afterAddToAcceptanceCalendar,
}) => {
  const requestDrawerVisible = useSelector(
    (state) => state.requestCardStore.requestDrawerVisible
  );

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setRequestDrawerVisible(false));

    if (typeof onClose === 'function') {
      onClose();
    }
  };

  return (
    <BottomDrawer visible={requestDrawerVisible} onClose={handleClose}>
      <RequestCard
        calendarIcon={calendarIcon}
        onCalendarClick={onCalendarClick}
        afterAddToAcceptanceCalendar={afterAddToAcceptanceCalendar}
      />
    </BottomDrawer>
  );
};

export default RequestCardDrawer;
